export const prepareCourses = ({
  courses,
  currentStudent,
}: {
  courses: any;
  currentStudent: any;
}) =>
  courses.map((course: any) => {
    const studentCourse = currentStudent.courses.find(
      (stCourse: any) => stCourse.id === course.id,
    );

    if (!studentCourse) {
      return {
        id: course.id,
        title: course.title,
        preview: course.preview,
        status: course.status,
        access: false,
      };
    }

    return {
      id: course.id,
      title: course.title,
      preview: course.preview,
      status: course.status,
      access: studentCourse.access,
    };
  });

export const convertDataToForm = (data: any) => ({
  courses: data
    .filter((course: any) => course.access)
    .map((course: any) => course.id),
});
